import { render, staticRenderFns } from "./FreightTableIdentificationSection.vue?vue&type=template&id=0b5e3648&scoped=true"
import script from "./FreightTableIdentificationSection.vue?vue&type=script&lang=js"
export * from "./FreightTableIdentificationSection.vue?vue&type=script&lang=js"
import style0 from "./FreightTableIdentificationSection.vue?vue&type=style&index=0&id=0b5e3648&prod&scoped=true&lang=less"
import style1 from "./FreightTableIdentificationSection.vue?vue&type=style&index=1&id=0b5e3648&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5e3648",
  null
  
)

export default component.exports